import { h, defineComponent, onMounted } from 'vue';
import { Button } from '@/ui/components/Button';
import { pageTitle } from '@/ui/components';
import { setLocale, t } from '@/ui/i18n/i18n';
import { setUser } from '@/services/telemetry';
import { hasSubscription, user } from '@/ui/auth/auth';
import { pushRoute } from '@/ui/helpers/uiHelper';

interface CenteredTitleSubtitlePageProps {
  title: string;
  subtitle: string;
  ctaTitle?: string;
  ctaLink?: string;
}

export const CenteredTitleSubtitlePage = defineComponent<CenteredTitleSubtitlePageProps>({
  props: ['title', 'subtitle', 'ctaTitle', 'ctaLink'],
  setup(props) {
    return function render() {
      setUser(user.value);
      setLocale(user.value.locale);

      onMounted(() => {
        if (hasSubscription()) {
          pushRoute({ name: 'home' });
        }
      });

      return h('div', { class: 'centered-title-subtitle-page' },
        [
          h('div', { class: 'centered-title-subtitle-page__content' }, [
            pageTitle(t(props.title)),
            h('div', { class: 'is-size-3' }, t(props.subtitle)),
            props.ctaTitle && props.ctaLink
              ? h('a', {
                attrs: {
                  class: 'mt-4',
                  href: props.ctaLink,
                },
              }, [h(Button, t(props.ctaTitle))])
              : null,
          ]),
        ]);
    };
  },
});
